import {default as Evidence} from './evidence-base';

export default Evidence;
